import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerLoyaltyPointCheckDiscount } from "../../../services/LoyaltyPoint/LoyaltyPoint";
import { getUserData } from "../../../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;
const CustomerLoyaltyPointLog = () => {
  const navigate = useNavigate();


  const location = useLocation();
  const { storeCustomerId, loyaltyPoint, storeId } = location.state || {};

  const handleBackButton = () => {
    navigate("/CustomerInfo", {
      state: {
        storeCustomerId: storeCustomerId,
        storeId: storeId,
      },
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Loyalty Point Log
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 h-full">
        <div className="flex-1 my-3 mt-5">
          <div
            className="flex-1 flex flex-row justify-content-around align-items-center"
            onClick={() =>
              navigate("/Customer-Loyalty-Point-Point-Log", {
                state: {
                  storeCustomerId: storeCustomerId,
                  loyaltyPoint: loyaltyPoint,
                  storeIdValue: storeId,
                },
              })
            }
            style={{ cursor: "pointer" }}
          >
            <div className="flex-1 flex align-self-center justify-content-center">
              <img
                src={"warehouse/gift-card.png"}
                style={{
                  alignSelf: "center",
                  width: height < 600 ? "30%" : "35%",
                }}
              />
            </div>
            <div className="flex flex-1 align-center flex-column">
              <div className="mx-2 py-1">
                <p
                  className="text-5xl font-bold text-center "
                  style={{ color: "#2B70D7" }}
                >
                  Awarded Log
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div
            className="flex-1 flex flex-row-reverse justify-content-around align-items-center"
            onClick={() =>
              navigate("/Customer-Loyalty-Point-Cash-Log", {
                state: {
                  storeCustomerId: storeCustomerId,
                  loyaltyPoint: loyaltyPoint,
                  storeIdValue: storeId,
                },
              })
            }
            style={{ cursor: "pointer" }}
          >
            <div className="flex-1 flex align-self-center justify-content-center">
              <img
                src={"warehouse/money.png"}
                style={{
                  alignSelf: "center",
                  width: height < 600 ? "30%" : "35%",
                }}
              />
            </div>
            <div className="flex flex-1 align-center flex-column">
              <div className="mx-2 py-1">
                <p
                  className="text-5xl font-bold text-center "
                  style={{ color: "#2B70D7" }}
                >
                  Redeem Log
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerLoyaltyPointLog;
